import { VendorStatus } from './constants/vendor-status.js';
export function applyVendorStatusIdChange(statusId) {
    if (statusId === VendorStatus.CANCELLED) {
        return { activeFlag: false, statusId };
    }
    return { statusId };
}
/** Relationship statuses editable in the form (Cancelled is set via Deactivate). */
export function isEditableVendorRelationshipStatus(statusId) {
    return statusId !== VendorStatus.CANCELLED;
}
//# sourceMappingURL=vendor-lifecycle.js.map